<template>
    <b-card no-body>

        <b-tabs>
            <b-tab title="Manutenção">

                <b-card-body>
                    <b-card bg-variant="light">
                        <b-form-row @keyup.enter="load" @submit.prevent="salvarSolicitacaoManutencao">
                            <b-col md="2" lg="2">
                                <lg-form-input v-model="form.numero" label="Número:"
                                    invalidFeedback="O número deve ser informado!" />
                            </b-col>
                            <b-col md="5" lg="5">
                                <lg-finder-page-unidade-administrativa id="finderUnidadeAdministrativaSM"
                                    @onselect="handleSelectUnidadeAdministrativa" v-model="form.unidadeAdministrativa"
                                    invalidFeedback="Informe uma unidade administrativa!"
                                    :prefix="prefix + title + ' > '" label="Unidade Administrativa:" />
                            </b-col>



                            <b-col md="6" lg="5">
                                <lg-finder-page-pessoa :prefix="prefix + title + ' > '" v-model="form.responsavel"
                                    id="finderPessoaSolicitacaoManutencao" @onselect="selectResponsavel"
                                    label="Responsável:" />
                            </b-col>
                            <!-- Segunda linha -->
                            <b-col md="3" lg="2">
                                <lg-form-date v-model="form.dataDe" label="De:" description=" "
                                    invalidFeedback="A data de deve ser informada!" />
                            </b-col>
                            <b-col md="3" lg="2">
                                <lg-form-date v-model="form.dataAte" label="Até:" description=" "
                                    style="margin-left:-15px;" invalidFeedback="A data limite deve ser informada!" />
                            </b-col>

                            <b-col md="4" lg="2">
                                <lg-form-input v-model="form.numTombamento" label="Tombamento:"
                                    invalidFeedback="Informe um tombamento válido!" />
                            </b-col>
                            <b-col md="4" lg="2">
                                <lg-form-input v-model="form.ate" label="Até:"
                                    invalidFeedback="O até deve ser informado!" />
                            </b-col>
                            <b-col lg="3"></b-col>
                            <b-col md="4" lg="3">
                                <lg-form-select v-model="form.status" @input="load" :loadFunction="statusList"
                                    labelFormGroupBind="Status:" label="descricao" description="" filterList="true" />
                            </b-col>

                            <b-col md="6" lg="3">
                                <lg-form-input v-model="form.numTombamentoSamp" label="Tombamento SAMP:"
                                    invalidFeedback="Informe um número SAMP válido!" />
                            </b-col>
                            <b-col md="6" lg="6" class="d-flex align-items-end justify-content-end">

                                <b-button id="limpar" class="my-2" size="sm" style="height: 40px" pill variant="primary"
                                    @click="limpar">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="eraser" />
                                    </div>
                                    <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                                </b-button>

                                <b-button id="loadSM" size="sm" style="height: 30px" pill variant="primary"
                                    @click="load()">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="search" />
                                    </div>
                                    <b-tooltip target="loadSM" title="Localizar"></b-tooltip>
                                </b-button>

                                <LgFinderPageItemBemPermanente ref="finderItemBemPermanente"
                                    id="finder-item-bem-permanente" @onselect="handleItemBemPermanenteSelect"
                                    mode='button' v-if="temPrivilegioCriar()" v-b-tooltip.hover
                                    title="Adicionar novo..." class="mx-2" />
                            </b-col>
                        </b-form-row>



                        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                            :fields="this.tableFields" :hover="true" show-empty>
                            <template #empty>
                                <p class="text-center">Nenhum registro encontrado</p>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                            <template v-slot:cell(aguardando)="{ item }">

                                <b-button @click="showModalAguardando(item)" :variant="'primary'"
                                    v-if="item.statusTarefa.id >= 234 && item.status.id < 238"
                                    v-b-tooltip.hover.top="getTooltip(item.statusTarefa && item.status.id ? item.statusTarefa.id : 234)">
                                    {{ getLabel(item.status && item.statusTarefa.id ? item.statusTarefa.id : 234) }}
                                </b-button>

                            </template>
                            <template v-slot:cell(enviarSolicitacao)="{ item }">
                                <b-button v-b-tooltip.hover.top="'Enviar Solicitação'"
                                    v-if='item.status.id == 230 && temPrivilegioEnviar()'
                                    @click="enviarSolicitacao(item)" variant="primary">
                                    <b-icon icon="box-arrow-right" />
                                </b-button>
                            </template>
                            <template v-slot:cell(editar)="{ item }">
                                <b-button v-b-tooltip.hover.top="'Editar'"
                                    v-if='item.status.id == 230 && temPrivilegioEdicao()' @click='editSolicitacao(item)'
                                    variant="primary">
                                    <b-icon icon="pencil-square" />
                                </b-button>
                            </template>
                            <template v-slot:cell(remover)="{ item }">
                                <b-button v-b-tooltip.hover.top="'Remover'" v-if='item.status.id == 230'
                                    @click="$removeResource(item)" variant="primary">
                                    <b-icon icon="trash2" />
                                </b-button>
                            </template>


                        </b-table>
                        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{
                                    page }} de {{
                                        totalPage }} -
                                    {{ total }} registros</b-col>
                                <b-col cols="6"
                                    style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                    <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                        :options="perPageOptions">
                                    </b-form-select>
                                </b-col>
                            </b-col>
                            <b-col cols="6">
                                <div class="d-flex justify-content-end align-items-end">
                                    <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                        :per-page="perPage" :total-rows="total"></b-pagination>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-card-body>
                <b-modal @hidden="fechar" size="xl" button-size="sm" hide-footer :id="this.modalProblemaRelatadoId"
                    title="Problema Relatado:">
                    <div class="form-outline">
                        <textarea v-model="form.problemaRelatado" class="form-control" id="textAreaExample3"
                            rows="2"></textarea>
                    </div>

                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvar" class=" my-2" size="sm" pill variant="success"
                                @click="salvarSolicitacaoManutencao">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvar" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button @click="fechar" id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>
                </b-modal>


            </b-tab>
            <b-tab v-if="showTarefasTab" title="Tarefas">
                <TarefaManutencao></TarefaManutencao>
            </b-tab>
        </b-tabs>
        <b-modal size="xl" button-size="sm" hide-footer id="tipoDeManutencao" @hidden="closeTipoDeManutencao"
            :title="prefix + title + ' > Manutenção de Item Bem Permanente'">
            <TipoDeManutencaoList :prefix="prefix + title + ' > '" :mostrarAdicionar="false"
                :idSolicitacao="idSolicitacaoSelecionada" @close='closeTipoDeManutencao' />
        </b-modal>
    </b-card>
</template>

<script>
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import moment from "moment"
import Swal from "sweetalert2"
import LgFinderPageItemBemPermanente from "@/components/Finders/LgFinderPageItemBemPermanente.vue"
import TarefaManutencao from "./TarefaManutencao.vue"
import TipoDeManutencaoList from "./TipoDeManutencaoList.vue"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"


export default {
    components: {
        LgFormInput,
        LgFinderPageUnidadeAdministrativa,
        LgFormDate,
        LgFormSelect,
        LgFinderPagePessoa,
        TarefaManutencao,
        LgFinderPageItemBemPermanente,
        TipoDeManutencaoList
    },
    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

    props: {
        idItemBemPermanente: {
            type: Number,
            default: null,
        },
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Solicitação Manutenção"
        },
        showTarefasTab: {
            type: Boolean,
            default: true
        }
    },

    created() {
        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.unidadeAdministrativa, this.departamentoLogado = brand.departamento
        this.form.usuario = brand.usuario
    },

    data() {
        return {
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            mostrarComponente: false,
            mostrarModal: false,
            modal: false,
            modalProblemaRelatadoId: "modalProblemaRelatadoId",
            modalSolicitacaoAguardandoId: "modalSolicitacaoAguardandoId",
            modalSolicitacaoFinalizadoId: "modalSolicitacaoFinalizadoId",
            filtro: {},
            departamentoLogado: null,
            idSolicitacaoSelecionada: null,
            form: {
                unidadeAdministrativa: {},
                responsavel: {},
                usuario: {},

                ate: "",
                dataDe: "",
                dataAte: "",
                numTombamento: "",
                numTombamentoSamp: "",
                problemaRelatado: "",
                numero: "",
                status: { id: null, descricao: 'Todos' },
                solicitacaoManutencao: "",
                modalData: null,
            },
        }
    },

    beforeMount() {
        this.$serviceStatus = new ResourceService(`/api/status`)
        this.$service = new ResourceService(`/api/solicitacaomanutencao`)
        this.$statusService = new ResourceService(
            `/api/status/tipo/descricao/Solicitação Manutenção Item Bem Permanente`
        )
    },

    mounted() {
        this.load()
    },
    watch: {
        page() {
            this.load()
        },

    },
    computed: {
        tableFields() {
            return [
                { key: "id", label: "Nº" },
                {
                    key: "dhCriacao",
                    label: "Abertura",
                    formatter: (value) => !value || value == "" ? "" : moment(value).format("DD/MM/YYYY"),
                },
                { key: "numTombamento", label: " Tomb. SPALM" },
                { key: "s_numTombAntigo", label: "Tombamento Samp" },
                {
                    key: "descricaoResumida",
                    label: "Descrição",
                },
                { key: "problemaRelatado", label: "Problema Relatado" },
                { key: "siglaDepartamento", label: "Sigla" },
                { key: "pessoa.nome", label: "Responsavel" },
                { key: "status.descricao", label: "Status" },
                { key: "aguardando", label: "", tdClass: "w-1" },
                { key: "enviarSolicitacao", label: "", tdClass: "w-1" },
                { key: "editar", label: "", tdClass: "w-1" },
                { key: "remover", label: "", tdClass: "w-1" },
                { key: "finalizando", label: "", tdClass: "w-1" },

            ]
        },
    },
    methods: {
        getLabel(id) {

            switch (id) {
                case 234:
                    return "A"
                case 235:
                    return "EA"
                case 236:
                    return "R"
                case 237:
                    return "M"
                case 238:
                    return "F"

            }

            return "E"
        },
        getTooltip(id) {

            switch (id) {
                case 234:
                    return "Aguardando"
                case 235:
                    return "Em atendimetno"
                case 236:
                    return "Recolhido"
                case 237:
                    return "Movimentado"
                case 238:
                    return "Finalizado"

            }
        },
        limpar() {
            this.form = {
                unidadeAdministrativa: {},
                responsavel: {},
                usuario: {},

                ate: "",
                dataDe: "",
                dataAte: "",
                numTombamento: "",
                numTombamentoSamp: "",
                problemaRelatado: "",
                numero: "",
                status: "",
                solicitacaoManutencao: "",
                modalData: null,
            };
            this.load();
        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOVIMENTACAO_EDITAR);

        },
        temPrivilegioCriar() {
            return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOVIMENTACAO_INCLUIR);

        },

        temPrivilegioEnviar() {
            return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOVIMENTACAO_ENVIAR);

        },

        temPrivilegioExcluir() {
            return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOVIMENTACAO_EDITAR);

        },

        handleSelectUnidadeAdministrativa(item) {
            this.form.unidadeAdministrativa = item
            this.load()
        },
        selectResponsavel(item) {
            this.form.responsavel = item
            this.load()
        },
        async load() {
            const params = {
                size: this.perPage,
                page: this.page - 1,
            }
            params.ibp = this.idItemBemPermanente

            if (this.form.numero) {
                params.id = this.form.numero
            }

            if (this.form.numTombamento) {
                params.numTombamento = this.form.numTombamento
            }

            if (this.form.ate) {
                params.numTombamentoAte = this.form.ate
            }


            if (this.form.unidadeAdministrativa && this.form.unidadeAdministrativa.id) {
                params.departamentoCod = this.form.unidadeAdministrativa.id
            }

            if (this.form.numTombamentoSamp) {
                params.numTombamentoSamp = this.form.numTombamentoSamp
            }

            if (this.form.dataDe) {
                params.dataDe = new Date(this.form.dataDe).toISOString()
            }

            if (this.form.dataAte) {
                params.dataAte = new Date(this.form.dataAte).toISOString()
            }

            if (this.form.status && this.form.status.id) {
                params.status = this.form.status.id
            }

            if (this.form.responsavel && this.form.responsavel.id) {
                params.responsavelId = this.form.responsavel.id
            }

            this.busy = true

            const response = await this.$service.findAll({ params })
            this.records = response.data.content
            this.total = response.data.totalElements
            this.totalPage = response.data.totalPages
            this.busy = false
        },

        async removerResource(item) {
            this.$removeResource(item)
        },

        async statusList({ filter, page = 1 }) {
            return this.$statusService.findAll({ filter, page, limit: 5 })
        },
        showRemover({ status }) {
            return status.descricao == "Em Conferência"
        },

        async handleItemBemPermanenteSelect(item) {
            if (item && item.id) {
                this.$set(this.form, "itemBemPermanenteSelect", item.id)
                await this.$bvModal.show(this.modalProblemaRelatadoId)

            }
        },

        async salvarSolicitacaoManutencao() {

            try {
                this.busy = true;
                this.$bvModal.hide(this.modalProblemaRelatadoId);
                const solicitacaoManutencaoCreateIntent = {
                    id: this.idSolicitacaoSelecionada,
                    problemaRelatado: this.form.problemaRelatado,
                    itemBemPermanente: this.form.itemBemPermanenteSelect,
                };
                await this.$saveResource(solicitacaoManutencaoCreateIntent, "", false, {}, false, true);
                this.busy = false;
                this.form.problemaRelatado = ""
                this.idSolicitacaoSelecionada = null
                this.load()
            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });
            }
        },

        async fechar() {
            this.idSolicitacaoSelecionada = null;
            this.form.problemaRelatado = "";
            this.$bvModal.hide(this.modalProblemaRelatadoId)
        },

        async show() {
            await this.$refs.finder.show()
            this.$bvModal.show(this.id)
        },

        async showModal() {
            this.$bvModal.show(this.modalProblemaRelatadoId)
        },

        closeTipoDeManutencao() {
            this.$bvModal.hide("tipoDeManutencao")
        },

        async showModalAguardando(item) {
            this.idSolicitacaoSelecionada = item.id
            this.$bvModal.show("tipoDeManutencao")
        },

        async showModalFinalizado(item) {
            this.form.modalData = item

            this.$bvModal.show(this.modalSolicitacaoFinalizadoId)
        },

        async enviarSolicitacao({ id }) {
            const value = await Swal.fire({
                title: `Enviar solicitacao ${id}?`,
                text: "Esta ação não poderá ser desfeita!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value
            })

            if (!value) {
                return
            }

            try {
                this.busy = true;
                await this.$service.post(`${id}/enviar`, {});
                this.busy = false;
                this.load()
                this.$notify({
                    type: "success",
                    message: `Solicitação ${id} enviada com sucesso!`,
                })
            } catch (err) {
                this.$notify({
                    type: "danger",
                    message: `Erro ao enviar a solicitação ${id}!`,
                })
            }
        },
        async editSolicitacao(item) {
            this.idSolicitacaoSelecionada = item.id
            this.form.problemaRelatado = item.problemaRelatado;

            await this.$bvModal.show(this.modalProblemaRelatadoId)

        },
    },
}
</script>
